import React from "react";
import { Updater } from "use-immer";

import { IgCheckbox, IgTypography } from "@intelligems/ig-theme";
import { UserBehaviorFilterType } from "@intelligems/ig-types";
import { FormControlLabel } from "@mui/material";
import Grid from "@mui/material/Grid";

import { IExperienceDashboardFilters } from "../../../store/types/dashboardFilters";

interface UserBehaviorViewsFilterProps {
  userBehavior: UserBehaviorFilterType;
  setDialogFilters: Updater<IExperienceDashboardFilters>;
}
export const UserBehaviorViewsFilter = ({
  setDialogFilters,
  userBehavior,
}: UserBehaviorViewsFilterProps) => {
  const onChange = (
    checked: boolean | null,
    filterKey: "viewedProductPage" | "viewedCollectionPage"
  ) => {
    setDialogFilters((draft) => {
      draft.userBehavior[filterKey] = checked ? true : null;
      return draft;
    });
  };
  return (
    <Grid container direction={"column"}>
      <Grid
        container
        direction={"row"}
        alignItems={"center"}
        justifyContent={"space-between"}
      >
        <Grid>
          <Grid>
            <Grid container>
              <Grid>
                <FormControlLabel
                  checked={Boolean(userBehavior.viewedCollectionPage)}
                  control={
                    <IgCheckbox
                      size={"small"}
                      onChange={(e) =>
                        onChange(e.target.checked, "viewedCollectionPage")
                      }
                    />
                  }
                  label={<IgTypography>Visited Collection</IgTypography>}
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      <Grid
        container
        direction={"row"}
        alignItems={"center"}
        justifyContent={"space-between"}
      >
        <Grid>
          <Grid container>
            <Grid>
              <FormControlLabel
                checked={Boolean(userBehavior.viewedProductPage)}
                control={
                  <IgCheckbox
                    size={"small"}
                    onChange={(e) =>
                      onChange(e.target.checked, "viewedProductPage")
                    }
                  />
                }
                label={<IgTypography>Visited Product Page</IgTypography>}
              />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};
